import {
    SET_FNOL_DATA, SET_TEMPLATE_DATA
} from './../constants/constants';

const initialState = {
    step: 1,
    subStep: 1,
    stepConfiguration: {
        steps:
            [
                { maxSubSteps: 1, step: 1, maxMobileSubSteps: 1 },
                { maxSubSteps: 1, step: 2, maxMobileSubSteps: 1 },
                { maxSubSteps: 1, step: 3, maxMobileSubSteps: 1  },
                { maxSubSteps: 1, step: 4, maxMobileSubSteps: 1  },
                { maxSubSteps: 2, step: 5, maxMobileSubSteps: 2  },
                { maxSubSteps: 0, step: 6, maxMobileSubSteps: 0  },
                { maxSubSteps: 0, step: 7, maxMobileSubSteps: 0  },
                { maxSubSteps: 0, step: 8, maxMobileSubSteps: 0  },
                { maxSubSteps: 0, step: 9, maxMobileSubSteps: 0  },
                { maxSubSteps: 0, step: 10, maxMobileSubSteps: 0  },
                { maxSubSteps: 5, step: 11, maxMobileSubSteps: 1  }]
    },

}

const TemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TEMPLATE_DATA:
            return {
                ...state,
                step: ('step' in action.payload) ? action.payload.step : state.step,
                subStep: ('subStep' in action.payload) ? action.payload.subStep : state.subStep,
                stepConfiguration: ('stepConfiguration' in action.payload) ? action.payload.stepConfiguration : state.stepConfiguration

            }
        default:
            return state
    }
}

export default TemplateReducer;